export const MODULE_NAME = 'AREA_MODULE';
